import { Chessboard as ReactChessboard } from "react-chessboard"
import { useGame } from "@/hooks/useGame"
import BoardControls from "./BoardControls"
import BoardBackground from "./BoardBackground"
import Annotations from "./Annotations"
import MovesList from "./MovesList"
import { useGameMoves } from "@/hooks/useGameMoves"
import ScrollProvider from "../ScrollProvider"
import Analysis from "./Analysis"

const EmbeddedChessScreen = () => {
  const {
    game,
    movesHistory,
    activeMove,
    isDraggablePiece,
    onPieceDrop,
    onPieceDragBegin,
    onSquareClick,
    optionSquares,
  } = useGameMoves()
  const { orientation } = useGame()

  return (
    <ScrollProvider dependency={activeMove}>
      {(movesContainerRef) => (
        <>
          <div className="z-20 flex h-10 shrink-0 items-center justify-center border-b border-gray-200 bg-white px-4 shadow-xs">
            <p className="text-center text-sm font-medium text-pretty text-gray-700">
              Save your games at{" "}
              <a
                href="https://chessdrop.com/"
                target="_blank"
                rel="noreferrer noopener"
                className="text-chessdrop-700 underline hover:decoration-2"
              >
                ChessDrop.com
              </a>
            </p>
          </div>

          <main className="relative z-10 flex flex-col min-[1500px]:pr-[500px] lg:flex-1 lg:pr-[335px] xl:pr-96">
            <BoardBackground compact>
              <ReactChessboard
                boardOrientation={orientation}
                position={game.fen()}
                areArrowsAllowed={false}
                onSquareClick={onSquareClick}
                autoPromoteToQueen={false}
                onPromotionCheck={() => false}
                customDarkSquareStyle={{
                  backgroundColor: "#c56c1a",
                }}
                customLightSquareStyle={{
                  backgroundColor: "#ffd17f",
                }}
                onPieceDragBegin={(_piece, sourceSquare) =>
                  onPieceDragBegin(sourceSquare)
                }
                isDraggablePiece={({ piece }) => isDraggablePiece(piece)}
                onPieceDrop={(sourceSquare, targetSquare) =>
                  onPieceDrop(sourceSquare, targetSquare)
                }
                customSquareStyles={optionSquares}
              />
            </BoardBackground>

            <div className="flex grow flex-col-reverse justify-end overflow-y-auto border-t border-gray-200 bg-gray-50 min-[1500px]:w-[500px] lg:fixed lg:top-10 lg:right-0.5 lg:bottom-0.5 lg:z-50 lg:flex lg:w-[335px] lg:flex-col lg:justify-start lg:border-t-0 lg:border-l lg:bg-white xl:w-96">
              <div className="pb-safe flex h-1/2 flex-col border-t border-gray-200 bg-gray-50 lg:border-t-0 lg:border-b lg:pb-0">
                <div
                  ref={movesContainerRef}
                  className="flex min-h-[100px] shrink-0 flex-col items-start justify-start space-y-1.5 overflow-auto scroll-smooth px-4 py-6 lg:px-6"
                >
                  <MovesList depth={0} moves={movesHistory} />
                </div>
                <Annotations isOwner={false} compact />
              </div>

              <div className="bg-white px-4 pt-4 lg:px-6">
                <Analysis />
                <BoardControls />
              </div>
            </div>
          </main>
        </>
      )}
    </ScrollProvider>
  )
}

export default EmbeddedChessScreen
